import React, { useEffect, useState } from 'react';
import { Redirect } from 'react-router-dom';
import { useSnackbar } from 'notistack';
import { useDispatch } from 'react-redux';
import { logoutUser } from 'modules/user';
import LoadingIndicator from 'components/LoadingIndicator';

export default function Logout() {
  const dispatch = useDispatch();
  const [logoutCompleted, setLogoutCompleted] = useState(false);
  const { enqueueSnackbar } = useSnackbar();

  useEffect(() => {
    const logout = async () => {
      await dispatch(logoutUser());

      enqueueSnackbar('You\'re safely logged out!', { variant: 'success' });

      setLogoutCompleted(true);
    };

    if (!logoutCompleted) logout();
  }, [logoutCompleted, dispatch, enqueueSnackbar]);

  return !logoutCompleted ? <LoadingIndicator /> : <Redirect to="/" />;
};
